import {
  getToken,
  setToken,
  removeToken,
  setUsuario,
  setOpciones,
  getUsuario,
  removeUsuario
} from "@/utils/auth";
import UsuarioApi from "@/api/usuarios";
import router from "@/router";
import { crypt, decrypt } from "@/utils/functions";

const getDefaultState = () => {
  return {
    token: getToken(),
    usuario: getUsuario(),
    correo: "",
    observacion: "",
    qr: "",
    secret: "",
    opciones: [],
    modulos: []
  };
};

export default {
  namespaced: true,

  state: getDefaultState(),

  getters: {
    observacion: (state) => state.observacion,
    token: (state) => state.token,
    qr: (state) => state.qr,
    secret: (state) => state.secret,
    usuario: (state) => state.usuario,
    correo: (state) => state.correo,
    opciones: (state) => state.opciones,
    isAuthenticated: (state) => !!state.token
  },

  mutations: {
    RESET_STATE: (state) => {
      Object.assign(state, getDefaultState());
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER: (state, usuario) => {
      state.usuario = usuario;
    },
    SET_CORREO: (state, correo) => {
      state.correo = correo;
    },
    SET_MODULOS: (state, modulos) => {
      state.modulos = modulos;
    },
    SET_OBSERVACION: (state, observacion) => {
      state.observacion = observacion;
    },
    SET_QR: (state, qr) => {
      state.qr = qr;
    },
    SET_SECRET: (state, secret) => {
      state.secret = secret;
    },
    SET_OPCIONES: (state, opciones) => {
      state.opciones = opciones;
    },
  },

  actions: {
    login: async ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        UsuarioApi.login(payload)
          .then((response) => {
            const { token, usuario, opciones,qr,secret } = response;

            var x_crypt = crypt(opciones);

            commit("SET_QR", qr);
            commit("SET_SECRET", secret);

            commit("SET_TOKEN", token);
            commit("SET_USER", usuario);
            commit("SET_OPCIONES", x_crypt);

            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },

    validateAuth: async ({ commit,state }, payload) => {
      return new Promise((resolve, reject) => {
        UsuarioApi.validarGoogle2FA(payload)
          .then((response) => {

            const token = state.token;
            const usuario = state.usuario;
            const x_crypt = state.opciones;

            setUsuario(usuario);
            setOpciones(x_crypt);
            setToken(token);

            router.push({ name: "inicio" });

            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },

    // get user info
    getModulos({ commit }) {
      return new Promise((resolve, reject) => {
        UsuarioApi.getModulos()
          .then((response) => {
            const modulos = response || [];

            const menuInicio = {
              ruta: "/"
            };
            const menuMicuenta = {
              ruta: "/micuenta"
            };

            modulos.push(menuInicio);
            modulos.push(menuMicuenta);

            commit("SET_MODULOS", modulos);
            // setModulos(data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            commit("RESET_STATE");
          });
      });
    },

    // user logout
    logout({ commit }, usuario) {
      return new Promise((resolve, reject) => {
        UsuarioApi.logout(usuario)
          .then(() => {
            removeToken();
            removeUsuario();
            commit("RESET_STATE");
            router.push({ name: "login" });
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    setUsuario({ commit }, payload) {
      commit("SET_USER", payload);
      setUsuario(payload);
    },

    resetToken({ commit }) {
      return new Promise((resolve) => {
        removeToken();
        removeUsuario();
        commit("RESET_STATE");
        resolve();
      });
    },

    setFilter: ({ commit }, payload) => {
      commit("SET_FILTER", payload);
    },
    setSearch: ({ commit }, payload) => {
      commit("SET_SEARCH", payload);
    },
    setCorreo: ({ commit }, payload) => {
      commit("SET_CORREO", payload);
    },
    setObservacion: ({ commit }, payload) => {
      commit("SET_OBSERVACION", payload);
    },
    cleanFilters: ({ commit }) => {
      commit("CLEAN_FILTERS");
    },
    setMenuActive: ({ commit }, payload) => {
      commit("SET_MENU_ACTIVE", payload);
    }
  }
};
